module.exports = __webpack_public_path__ + "media/images/vp/header.phone-2720580ad95d062552118c28af70b0bf.png";